<template>
  <b-container>
    <b-container fluid="sm" style="padding-top: 20px">


      <b-card bg-variant="light">
        <group-selector v-model="createdUserGroup" :available-groups="groupList" :show-ids="true"></group-selector>
        <b-form-group label-cols="4" label-cols-lg="2" label-size="md" label="First Name" label-for="first-name">
          <b-form-input id="first-name" size="sm" v-model="firstName"/>
        </b-form-group>

        <b-form-group label-cols="4" label-cols-lg="2" label-size="md" label="Last Name" label-for="last-name">
          <b-form-input id="last-name" size="sm" v-model="lastName"/>
        </b-form-group>

        <b-form-group label-cols="4" label-cols-lg="2" label-size="md" label="Street Address"
                      label-for="streetAddress">
          <b-form-input id="streetAddress" size="sm" v-model="streetAddress"/>
        </b-form-group>
        <b-form-group label-cols="4" label-cols-lg="2" label-size="md" label="City"
                      label-for="city">
          <b-form-input id="city" size="sm" v-model="city"/>
        </b-form-group>
        <b-form-group label-cols="4" label-cols-lg="2" label-size="md" label="State"
                      label-for="state">
          <b-form-input id="state" size="sm" v-model="state"/>
        </b-form-group>
        <b-form-group label-cols="4" label-cols-lg="2" label-size="md" label="Zip Code"
                      label-for="zipCode">
          <b-form-input id="zipCode" size="sm" v-model="zipCode"/>
        </b-form-group>

        <b-form-group label-cols="4" label-cols-lg="2" label-size="md" label="Telephone Number"
                      label-for="input-sm">
          <b-form-input id="telephoneNumber" size="sm" v-model="telephoneNumber"/>
        </b-form-group>


        <b-form-group label-cols="4" label-cols-lg="2" label-size="md" label="Email " label-for="email">
          <b-form-input id="email" size="sm" v-model="email"/>
        </b-form-group>

        <b-form-group label-cols="4" label-cols-lg="2" label-size="md" label="Username" label-for="username">
          <b-form-input id="username" size="sm" v-model="username"/>
        </b-form-group>
        <b-form-group label="Roles:" v-slot="{ ariaDescribedby }">
          <b-form-checkbox-group
              id="groupRoles"
              v-model="roles"
              :options="rolesOptions"
              stacked
              :aria-describedby="ariaDescribedby"
              name="groupRoles">
          </b-form-checkbox-group>
        </b-form-group>
        <b-form-group label="User Status:" v-slot="{ ariaDescribedby }">
          <b-form-radio-group
              id="accountStatus"
              v-model="enabled"
              :options="statusOptions"
              :unchecked-value="false"
              stacked
              :aria-describedby="ariaDescribedby"
              name="accountStatus">
          </b-form-radio-group>
        </b-form-group>
        <b-container fluid="sm">
          <div class="button-holder">
            <b-button class="submit-button" type="submit" @click="submit('userInfo')"
                      :disabled="!canSubmit" variant="primary">
              Submit
            </b-button>

            <b-button class="cancel-button" type="cancel" @click="cancel" variant="primary">Cancel
            </b-button>
          </div>
        </b-container>
      </b-card>
    </b-container>
  </b-container>

</template>

<script>
import Swal from "sweetalert2";
import GroupSelector from "@/components/admin/GroupSelector";

const emailRegex = /^([^@\s]+)@((?:[-a-z0-9]+\.)+[a-z]{2,})$/i;

export default {
  name: "CreateUser.vue",
  props: {
    groupId: String
  },
  components: {
    GroupSelector
  },
  data() {
    return {
      myGroupId: this.groupId || localStorage.getItem('adminImpersonationGroupId') || localStorage.getItem('groupId'),
      groupList: [],
      groupRoleList: [],
      createdUserGroup: [],
      roles: ['USER'],
      companyName: '',
      firstName: '',
      lastName: '',
      streetAddress: '',
      city: '',
      state: '',
      zipCode: '',
      telephoneNumber: '',
      username: '',
      email: '',
      enabled: 'ENABLED',
      errors: [],
      isSubmitted: true,
      rolesOptions: ['GROUP_ADMIN', 'USER', 'VIEWER', 'THIRD_PARTY_CERTIFIER', "VINEYARD_ADMIN"],
      statusOptions: ['ENABLED', 'DISABLED']

    }
  },
  computed: {
    computedCompany: function () {
      let self = this;
      if (this.groupList) {
        let company = this.groupList.find(function (val) {
          return val.id === self.createdUserGroup;
        });
        this.companyName = company ? company.name.split("(")[0] : "";
        return company ? company.name : "";
      }
      return "";
    },
    validateBusinessName: function () {
      return this.createdUserGroup !== null;
    },
    validateFirstName: function () {
      return this.firstName !== '';
    },
    validateLastName: function () {
      return this.lastName !== '';
    },
    validateTelephoneNumber: function () {
      return this.telephoneNumber !== '';
    },
    validateContactEmail: function () {
      return this.validateEmailAddress(this.email);
    },
    validateUsername: function () {
      return this.username !== '';
    },
    canSubmit: function () {
      return this.validateContactEmail && this.validateTelephoneNumber
          && this.validateFirstName && this.validateLastName && this.validateBusinessName
          && this.validateUsername && this.createdUserGroup.length > 0;
    }
  },
  mounted() {
    console.log("About To mount");
    let self = this;
    this.$http.get('account/role-types')
        .then(result => {
          if (result.status === 200) {
            self.rolesOptions = result.data.map(val => {
              if (val === 'ADMIN') {
                return {text: val, value: val.toLowerCase()};
              }
              return {text: val, value: val};
            });
          }
        })
        .catch(error => {
          console.log("Unable to retrieve roles, falling back.", error);
        })
    this.$http.get("groups")
        .then(resp => {
          self.groupList = resp.data;
        })
        .catch(error => {
          alert("Unable to retrieve groups");
          alert(error);
        });
    this.loadAccessibleGroups();
  },
  methods: {
    loadAccessibleGroups: function () {
      console.log("Getting list of groups can add to");
      let self = this;
      this.$http.get(`account/user/${localStorage.getItem('user')}/group-admin`)
          .then(result => {
            let adminGroups = [];
            let groupsSet = Object.entries(result.data);
            groupsSet.forEach(group => {
              adminGroups.push({
                selected: self.groups.includes(group[0]),
                id: group[0],
                name: group[1],
                groupAdminRole: self.groups.includes(group[0]) && self.groupRoleList.filter(groupItem => groupItem.groupId === group[0]).map(it => it.role).includes("GROUP_ADMIN"),
                viewer: self.groups.includes(group[0]) && self.groupRoleList.filter(groupItem => groupItem.groupId === group[0]).map(it => it.role).includes("VIEWER")
              })
            });
            self.groupsList = adminGroups;
          }).catch(err => {
        console.log('Error Caught');
        console.log(err.reason);
        console.log(err);
      });
    },

    onChangeList: function ({source, destination}) {
      this.groupsList = source;
      this.createdUserGroup = Array.from(new Set(destination));
    },
    changedLabel: function () {
      alert("Group Selected");
    },
    validateEmailAddress: function (email) {
      return emailRegex.test(String(email).toLowerCase());
        },
        isFieldValid: function (fieldValue, defaultValue) {
          console.log(Object.keys(fieldValue));
          return fieldValue !== defaultValue && fieldValue !== "";
        },
        submit: function () {
          let self = this;
          let data;
          let url;

          url = 'account/user';
          data = {
            firstName: this.firstName,
            lastName: this.lastName,
            company: this.companyName,
            streetAddress: this.streetAddress,
            city: this.city,
            state: this.state,
            zipCode: this.zipCode,
            telephoneNumber: this.telephoneNumber,
            username: this.username,
            email: this.email,
            groupRoleList: this.createdUserGroup.map(group => {
              let roles = ["USER"];
              if (group.groupAdminRole) {
                roles.push("GROUP_ADMIN")
              }
              if (group.viewer) {
                roles.push("VIEWER")
              }
              return roles.map(theRole => {
                return {role: theRole, groupId: group.id}
              });
            })
                .flat(),
            enabled: this.enabled === "ENABLED"
          };

          this.$http.post(url, data, {
            headers: {
              'content-type': 'application/json'
            }
          })
              .then(function (response) {
                if (response.status === 202 || response.status === 200) {
                  self.displayResult(`Account Created successfully.`);
                  self.clearForm();
                }
              })
              .catch(function (error) {
                let issuesObject = error.response.data[0];
                Swal.fire("Account Creation Failed", `Creation failed, user with ${issuesObject.field} = ${issuesObject.value} already exists.`, "error");
              });
        },
        clearForm: function () {
          this.firstName = '';
          this.lastName = '';
          this.company = '';
          this.streetAddress = '';
          this.city = '';
          this.state = '';
          this.zipCode = '';
          this.telephoneNumber = '';
          this.username = '';
          this.email = '';
          this.createdUserGroup = [];
          this.roles = []
        },
        cancel: function () {
          this.$router.push({path: '/my-account'});
        },
        displayResult: function (message) {
          this.$toasted.show(message,
              {
                containerClass: 'super-toasty',
                iconPack: 'fontawesome',
                closeOnSwipe: true,
                action: {
                  text: 'DISMISS',
                  onClick: (e, toastObject) => {
                    toastObject.goAway(0);
                  }
                },
                icon: {
                  name: 'fa-check-circle',
                  after: false,
                }
              })
              .goAway(5000);
        }
      }
}
</script>

<style scoped>
.cancel-button {
  margin-left: 10px;
  margin-top: 5px;
}

.submit-button {
  margin-left: 10px;
  margin-top: 5px;
}

.button-holder {
  horiz-align: center;
  display: flex; /*Requires vendor prefixes*/
  justify-content: center; /*Requires vendor prefixes*/
  align-items: center; /*Requires vendor prefixes*/
}
</style>
